import { createFileRoute } from "@tanstack/react-router";
import { getAllPosts } from "@/lib/posts.functions";
import { hreflangLinks } from "@/lib/seo";
import { ArchiveList } from "@/components/ArchiveList";
import { pageTitle } from "@/lib/brand";

// Legacy English archive path on the Turkish host. The canonical English
// archive lives on the English brand domain (/ideas), so both canonical
// and og:url self-reference that URL instead of the Turkish domain.
const EN_CANONICAL = "https://smartsustainability.ai/ideas";

export const Route = createFileRoute("/archive")({
  head: () => ({
    meta: [
      { title: pageTitle("Archive", "en") },
      { name: "description", content: "The full archive of essays on AI, climate systems, sustainability critique and human futures." },
      { property: "og:title", content: "Archive — Smart Sustainability" },
      { property: "og:description", content: "The full archive of essays on AI, climate systems, sustainability critique and human futures." },
      { property: "og:url", content: EN_CANONICAL },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "en_US" },
      { property: "og:locale:alternate", content: "tr_TR" },
      { property: "og:site_name", content: "Smart Sustainability" },
    ],
    links: [
      { rel: "canonical", href: EN_CANONICAL },
      ...hreflangLinks("/yazilar", "/ideas"),
    ],
  }),
  loader: () => getAllPosts(),
  component: () => <ArchiveList posts={Route.useLoaderData()} />,
});
